import { useMemo } from 'react';
import { searchCustomer, lookupOrder } from '../../services/claimsService';
import type { ClaimActor, CustomerMatch, OrderLookupResult } from '../../types/claims.types';

export interface ClaimLookups {
  degraded: boolean;
  searchCustomer: ((phone: string) => Promise<CustomerMatch | null>) | null;
  lookupOrder: ((orderNumber: string) => Promise<OrderLookupResult>) | null;
}

/**
 * Salon-scopede opslag. I admin-mode (degraded) er funktionerne null —
 * editoren viser en diskret note indtil tenant-aware 🔨-endpoints lander.
 */
export function useClaimLookups(actor: ClaimActor | null, degraded: boolean): ClaimLookups {
  const actorKey = actor ? `${actor.employeeId}` : '';
  return useMemo<ClaimLookups>(() => {
    if (degraded || !actor) {
      return { degraded: true, searchCustomer: null, lookupOrder: null };
    }
    return {
      degraded: false,
      searchCustomer: (phone: string) => searchCustomer(phone),
      lookupOrder: (orderNumber: string) => lookupOrder(orderNumber),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actorKey, degraded]);
}
